import { Avatar, AvatarProps, CircularProgress, styled } from "@mui/material";
import { useState } from "react";

type MxImageViewerProps = AvatarProps
const MxImageViewer = (props: MxImageViewerProps) => {
  const [loading, setLoading] = useState(true);

  const handleImageLoad = () => {
    setLoading(false);
  };

  return (
    <ImageContainer>
      {loading && <CircularProgress />}
      <StyledImage {...props} onLoad={handleImageLoad} loading={loading} />
    </ImageContainer>
  );
};

export default MxImageViewer;

const ImageContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  width: "100%",
  height: "100%",
  overflow: "hidden"
  // backgroundColor: "#f0f0f0"
});

const StyledImage = styled(Avatar as any)<{ loading: boolean }>(({ loading }) => ({
  minWidth: 50,
  minHeigh: 50,
  display: loading ? "none" : "block"
}));
